import React, { useState, useMemo, useRef, useEffect, useCallback, use } from "react";
import PropTypes from "prop-types"; // For prop-types validation
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { InputAdornment } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import DownloadIcon from "@mui/icons-material/Download";
import {
  TableContainer,
  Paper,
  Box,
  Dialog,
  DialogContent,
  CircularProgress,
  Typography,
  Autocomplete,
  TextField,
  Tooltip,
  Grid,
  Button, // Added Button import
} from "@mui/material";
import dayjs from "dayjs";
import {
  StyledButton,
  StyledAlert,
  StyledSnackbar,
  StyledAgGridContainer,
  inputStyle,
  ModernHeader,
} from "components/StyledComponents/styledComponents.js";
import { useNavigate } from "react-router-dom";
import useBusinessMonthYear from "components/GlobalHooks/useMonthlyBusiness";
import { writeFile, utils } from "xlsx"; // Import XLSX for Excel export
import DownloadForOfflineIcon from "@mui/icons-material/DownloadForOffline"; // Download icon for the button
import VisibilityIcon from "@mui/icons-material/Visibility"; // Visibility icon for invoice view
import { monthEndStyles } from "components/Styles/monthEndStyles";
import { CustomPaper } from "components/Styles/globalStyles";
import URLs from "constants/urls";
import Cookie from "js-cookie";
import { IconButton, Modal } from "@mui/material";
import ResponsiveTabs from "components/StyledComponents/styledComponents";
import { useMaterialUIController } from "context";
import TotalExpenditureStatement from "./expenses";
import { Eye } from "lucide-react";
import GstTdsGrid from "./gstComponent";
import FinancialSummary from "./newP&LSummary";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

export default function ActualProfitAndLoss() {
  const [expenseIsOpen, setExpenseIsOpen] = useState(false);
  const { monthIdData, setAlert, handleClose } = useBusinessMonthYear();
  const [controller] = useMaterialUIController(); // Get context state
  const { user } = controller; // Destructure user
  const [monthId, setMonthId] = useState(0);
  const [dsaId, setDsaId] = useState(0);
  const businessCodeRef = useRef(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchTermD, setSearchTermD] = useState("");
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [alertType, setAlertType] = useState("success");
  const [loading, setLoading] = useState(false);
  const [servicesData, setServicesData] = useState([]);
  const MInput = inputStyle();
  const currentMonthStart = dayjs().startOf("month").format("YYYY-MM-DD");
  const currentMonthEnd = dayjs().endOf("month").format("YYYY-MM-DD");
  const [startDate, setStartDate] = useState(currentMonthStart);
  const [endDate, setEndDate] = useState(currentMonthEnd);
  const [rowData, setRowData] = useState([]);
  const [dsaBusiness, setDsaBusiness] = useState([]);
  const [footerData, setFooterData] = useState([]);
  const [dsaFooterData, setDsaFooterData] = useState([]);
  const jwt_token = Cookie.get("jwt_token");
  const navigate = useNavigate();
  const [filteredData, setFilteredData] = useState([]);
  const [isFullView, setIsFullView] = useState(true);
  const [activeTab, setActiveTab] = useState(0);
  const [popoverOpen, setPopoverOpen] = useState(false);
  const [selectedDSA, setSelectedDSA] = useState(null);
  const [childGridData, setChildGridData] = useState([]);
  const [receivableFooterData, setReceivableFooterData] = useState([]);
  const [dsaReceivables, setDsaReceivables] = useState([]);
  const [footerChildGridData, setFooterChildGridData] = useState([]);
  const [recievablesAgainstInvoiceFooterData, setRecievablesAgainstInvoiceFooterData] = useState(
    []
  );
  const [companyId, setCompanyId] = useState(false);
  const [recievablesAgainstInvoiceData, setRecievablesAgainstInvoiceData] = useState([]);
  const [recievablesAgtInvData, setRecievablesAgtInvData] = useState([]);
  const [recievablesAgtInvfooterData, setRecievablesAgtInvfooterData] = useState([]);
  const [notRecievablesNanvoiceData, setNotRecievablesNanvoiceData] = useState([]);
  const [recievablesNotInvData, setRecievablesNotInvData] = useState([]);
  const [recievablesNotInvfooterData, setRecievablesNotInvfooterData] = useState([]);
  const [notRecievablesAgainstInvoiceFooterData, setNotRecievablesAgainstInvoiceFooterData] =
    useState([]);
  const [selectedRange, setSelectedRange] = useState("30");
  const [selectedDSAName, setSelectedDSAName] = useState(user?.dsaName || "");
  const [highlightAllRows, setHighlightAllRows] = useState(false);
  const [highlightAllRowsInv, setHighlightAllRowsInv] = useState(false);
  const ExpenditureCellRenderer = (params) => {
    const handleEyeClick = () => {
      // Call the onEyeClick function passed via params
      params.onEyeClick(params.data.dsaId);
    };

    return (
      <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-end" }}>
        <span style={{ marginRight: "8px" }}>
          {`₹ ${params.value?.toLocaleString("en-IN", { minimumFractionDigits: 2 })}`}
        </span>
        <button
          onClick={handleEyeClick}
          style={{
            background: "none",
            border: "none",
            cursor: "pointer",
            padding: "0",
            display: "flex",
            alignItems: "center",
          }}
        >
          <Eye size={22} color="#007bff" />
        </button>
      </div>
    );
  };

  const DaysFilterButtons = ({ onFilter, onDownload }) => {
    const ranges = [
      { label: "30 Days", days: 30 },
      { label: "60 Days", days: 60 },
      { label: "90 Days", days: 90 },
      { label: "Above 90", days: 91, above: true },
      { label: `ALL - ${selectedDSAName}`, days: 0, allByCom: true },
      { label: "All NoN Inv", days: -1, all: true },
    ];

    const handleClick = (label, days, isAbove, all, allByCom) => {
      setSelectedRange(days);
      setHighlightAllRows(all === true);

      const today = dayjs();
      let startDate = null;
      let endDate = null;

      if (all) {
        startDate = null;
        endDate = null;
      } else if (isAbove) {
        endDate = today.subtract(90, "day").format("YYYY-MM-DD");
      } else if (days === 30) {
        startDate = today.subtract(30, "day").format("YYYY-MM-DD");
        endDate = today.format("YYYY-MM-DD");
      } else if (days === 60) {
        startDate = today.subtract(60, "day").format("YYYY-MM-DD");
        endDate = today.subtract(31, "day").format("YYYY-MM-DD");
      } else if (days === 90) {
        startDate = today.subtract(90, "day").format("YYYY-MM-DD");
        endDate = today.subtract(61, "day").format("YYYY-MM-DD");
      }

      onFilter({ startDate, endDate, isAbove, all, allByCom });
    };

    return (
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: 2,
          mb: 1,
        }}
      >
        {ranges.map(({ label, days, above, all, allByCom }) => {
          const isSelected = selectedRange === days;

          return (
            <Button
              key={label}
              variant={isSelected ? "contained" : "outlined"}
              onClick={() => handleClick(label, days, above, all, allByCom)}
              sx={{
                borderRadius: "20px",
                textTransform: "none",
                fontWeight: 700,
                px: 2,
                py: 0.5,
                borderColor: "#FFA726",
                color: isSelected ? "#fff" : "#2E2E2E",
                backgroundColor: isSelected ? "#D46B08" : "#FFF3E0",
                transition: "all 0.3s ease",
                "&:hover": {
                  backgroundColor: isSelected ? "#FB8C00" : "#FFB74D",
                  borderColor: "#FB8C00",
                  boxShadow: isSelected
                    ? "0 0 12px rgba(255, 152, 0, 0.6)"
                    : "0 0 6px rgba(255, 152, 0, 0.3)",
                },
              }}
            >
              {label}
            </Button>
          );
        })}
        <Button
          variant="contained"
          color="success"
          startIcon={<DownloadIcon />}
          onClick={onDownload}
          sx={{
            borderRadius: "20px",
            textTransform: "none",
            fontWeight: 700,
            px: 3,
            py: 0.8,
            backgroundColor: "#2E7D32",
            color: "#ffffff",
            "&:hover": { backgroundColor: "#1B5E20" },
          }}
        >
          Download Excel
        </Button>
      </Box>
    );
  };

  DaysFilterButtons.propTypes = {
    onFilter: PropTypes.func.isRequired,
    onDownload: PropTypes.func.isRequired,
  };

  const handleOpenModal = () => {
    setExpenseIsOpen(true);
  };
  const handleCloseModal = () => {
    setExpenseIsOpen(false);
  };
  const handleChange = (event, newValue) => {
    setActiveTab(newValue);
  };
  const tabs = [
    { label: "P & L Report" },
    { label: "DSA'S P & L Report" },
    { label: "Estimated P & L" },
    { label: "Actual P & L" },
  ];
  const fetchEntriesByMonthId = async () => {
    if (startDate && endDate) {
      const formattedStartDate = dayjs(startDate).format("YYYY-MM-DD");
      const formattedEndDate = dayjs(endDate).format("YYYY-MM-DD");
      setLoading(true);
      try {
        const options = {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${jwt_token}`,
          },
        };
        const responseA = await fetch(
          `${URLs.actualProftLoassReport}?startDate=${formattedStartDate}&endDate=${formattedEndDate}`,
          options
        );
        const dataA = await responseA.json();

        if (responseA.ok) {
          setServicesData([...dataA]); // Combine both results
        } else {
          throw new Error("Failed to fetch entries data");
        }
      } catch (error) {
        showAlert(`Failed to fetch data: ${error.message}`, "error");
      } finally {
        setLoading(false);
      }
    } else {
      showAlert("Please select both start and end dates", "error");
    }
  };
  const fetchEntriesByDSAMonthId = async () => {
    if (startDate && endDate) {
      const formattedStartDate = dayjs(startDate).format("YYYY-MM-DD");
      const formattedEndDate = dayjs(endDate).format("YYYY-MM-DD");
      setLoading(true);
      try {
        const options = {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${jwt_token}`,
          },
        };
        const responseA = await fetch(
          `${URLs.dsaFinancialDetailss}?startDate=${formattedStartDate}&endDate=${formattedEndDate}`,
          options
        );
        const dataA = await responseA.json();

        if (responseA.ok) {
          setDsaBusiness([...dataA]);
        } else {
          throw new Error("Failed to fetch entries data");
        }
      } catch (error) {
        showAlert(`Failed to fetch data: ${error.message}`, "error");
      } finally {
        setLoading(false);
      }
    } else {
      showAlert("Please select both start and end dates", "error");
    }
  };
  const showAlert = (msg, type) => {
    setMessage(msg);
    setAlertType(type);
    setOpen(true);
  };
  const handleCloseAlert = () => {
    setOpen(false);
  };
  useEffect(() => {
    const filteredData = servicesData.filter((item) =>
      item.dsaName.toLowerCase().includes(searchTermD.toLowerCase())
    );
    setFilteredData(filteredData);
  }, [searchTermD, servicesData]);
  useEffect(() => {
    const filteredData = servicesData.filter((item) =>
      item.bankerName.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilteredData(filteredData);
  }, [searchTerm, servicesData]);
  useEffect(() => {
    if (monthIdData && monthIdData.length > 0) {
      // Set monthId only when monthIdData exists and is not empty
      setMonthId(monthIdData[0].businessMonthID);
      fetchEntriesByMonthId();
    }
  }, [monthIdData]);
  const handlePrintInvoice = useCallback(async (invoiceNo) => {
    try {
      if (!invoiceNo) {
        throw new Error("Invoice number is missing");
      }

      const response = await fetch(`${URLs.headOfficeInvoiceView}/${invoiceNo}`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${jwt_token}`,
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch invoice");
      }

      const blob = await response.blob();
      const pdfUrl = URL.createObjectURL(blob);

      // Open in a new tab
      window.open(pdfUrl, "_blank");
    } catch (error) {
      console.error("Error fetching invoice:", error);
    }
  }, []);
  const handlePrintKhInvoice = useCallback(async (invoiceNo) => {
    try {
      if (!invoiceNo) {
        throw new Error("Invoice number is missing");
      }

      const response = await fetch(`${URLs.khInvoiceViewUrl}/${invoiceNo}`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${jwt_token}`,
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch invoice");
      }

      const blob = await response.blob();
      const pdfUrl = URL.createObjectURL(blob);

      // Open in a new tab
      window.open(pdfUrl, "_blank");
    } catch (error) {
      console.error("Error fetching invoice:", error);
    }
  }, []);
  const ActionCellRenderer = (props) => {
    const handleDownload = () => {
      if (!servicesData.length || !ALL_COLUMN_DEFS.length) return;

      // Extract headers from column definitions
      const headers = ALL_COLUMN_DEFS.map((col) => col.headerName);

      // Map rowData to match the headers
      const rowData = servicesData.map((row) => {
        const rowObject = {};
        ALL_COLUMN_DEFS.forEach((col) => {
          rowObject[col.headerName] = row[col.field] || ""; // Map field values to headers
        });
        return rowObject;
      });

      // Create a worksheet with headers and rowData
      const ws = utils.json_to_sheet(rowData, { header: headers });

      // Create a workbook and append the sheet
      const wb = utils.book_new();
      utils.book_append_sheet(wb, ws, "EmployeeData");

      // Save the workbook
      writeFile(wb, "Monthly_Business_Entries_Data.xlsx");
    };

    return (
      <Box display="flex" alignItems="center" gap={2}>
        <TextField
          label="Search by Banker Name"
          variant="outlined"
          value={searchTerm}
          sx={{ ...MInput.b, maxWidth: "300px" }}
          onChange={(e) => setSearchTerm(e.target.value)}
          fullWidth
          margin="normal"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon fontSize="medium" />
              </InputAdornment>
            ),
          }}
        />
        <TextField
          label="Search by DSA Name"
          variant="outlined"
          value={searchTermD}
          sx={{ ...MInput.b, maxWidth: "300px" }}
          onChange={(e) => setSearchTermD(e.target.value)}
          fullWidth
          margin="normal"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon fontSize="medium" />
              </InputAdornment>
            ),
          }}
        />
        <StyledButton onClick={handleDownload}>
          <DownloadForOfflineIcon fontSize="medium" />
        </StyledButton>
      </Box>
    );
  };

  const triggerApiCall = () => {
    businessCodeRef.current = monthId;
    fetchEntriesByMonthId();
  };
  const triggerApiDsaBCall = () => {
    businessCodeRef.current = monthId;
    fetchEntriesByDSAMonthId();
    fetchReceivableData();
  };
  function formatDateToDDMonYYYY(dateString) {
    if (!dateString) return ""; // handle empty, null, or undefined

    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    const date = new Date(dateString);
    if (isNaN(date)) return ""; // invalid date check

    const day = String(date.getDate()).padStart(2, "0");
    const month = months[date.getMonth()];
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  }

  const ALL_COLUMN_DEFS = [
    {
      headerName: "Report Month",
      field: "reportMonth",
      filter: true,
      sortable: true,
      minWidth: 140,
      flex: 1,
    },
    {
      headerName: "Banker Name",
      field: "bankerName",
      filter: true,
      sortable: true,
      minWidth: 250,
      flex: 1,
    },
    {
      headerName: "Application Number",
      field: "applicationNumber",
      filter: true,
      sortable: true,
      minWidth: 200,
      flex: 1.5,
    },
    {
      headerName: "Date",
      field: "date",
      filter: true,
      sortable: true,
      minWidth: 130,
      flex: 1,
      valueFormatter: (params) => {
        const isFooter = params.data?.isFooter;
        return !isFooter ? formatDateToDDMonYYYY(params.value) : "";
      },
    },
    {
      headerName: "Product",
      field: "product",
      filter: true,
      sortable: true,
      minWidth: 100,
      flex: 1,
    },
    {
      headerName: "Customer Name",
      field: "customerName",
      filter: true,
      sortable: true,
      minWidth: 180,
      flex: 1.5,
    },
    {
      headerName: "Applied Amount",
      field: "appliedAmount",
      filter: true,
      sortable: true,
      minWidth: 180,
      flex: 1.5,
      cellStyle: { textAlign: "right", fontWeight: "500" },
      valueFormatter: (params) =>
        `₹ ${params.value?.toLocaleString("en-IN", { minimumFractionDigits: 2 })}`,
    },
    {
      headerName: "Net Disbursement",
      field: "netDisbursement",
      filter: true,
      sortable: true,
      minWidth: 200,
      flex: 1.5,
      cellStyle: { textAlign: "right", fontWeight: "500" },
      valueFormatter: (params) =>
        `₹ ${params.value?.toLocaleString("en-IN", { minimumFractionDigits: 2 })}`,
    },
    {
      headerName: "Actual Disbursement",
      field: "actualDisbursement",
      filter: true,
      sortable: true,
      minWidth: 200,
      flex: 1.5,
      cellStyle: { textAlign: "right", fontWeight: "500" },
      valueFormatter: (params) =>
        `₹ ${params.value?.toLocaleString("en-IN", { minimumFractionDigits: 2 })}`,
    },
    {
      headerName: "Est. Net %",
      field: "estNetPercent",
      filter: true,
      sortable: true,
      minWidth: 150,
      flex: 1,
      cellStyle: { textAlign: "right", fontWeight: "500" },
      valueFormatter: (params) =>
        params.value !== undefined && params.value !== null ? `${params.value.toFixed(2)}%` : "",
    },
    {
      headerName: "Act. Net %",
      field: "actNetPercent",
      filter: true,
      sortable: true,
      minWidth: 150,
      flex: 1,
      cellStyle: { textAlign: "right", fontWeight: "500" },
      valueFormatter: (params) =>
        params.value !== undefined && params.value !== null ? `${params.value.toFixed(2)}%` : "",
    },
    {
      headerName: "Estimate Revenue",
      field: "estimateRevenue",
      filter: true,
      sortable: true,
      minWidth: 180,
      flex: 1.5,
      cellStyle: { textAlign: "right", fontWeight: "500" },
      valueFormatter: (params) =>
        `₹ ${params.value?.toLocaleString("en-IN", { minimumFractionDigits: 2 })}`,
    },
    {
      headerName: "Actual Revenue",
      field: "actualRevenue",
      filter: true,
      sortable: true,
      minWidth: 180,
      flex: 1.5,
      cellStyle: { textAlign: "right", fontWeight: "500" },
      valueFormatter: (params) =>
        `₹ ${params.value?.toLocaleString("en-IN", { minimumFractionDigits: 2 })}`,
    },
    {
      headerName: "Disbursement Diff",
      field: "diffDisb",
      filter: true,
      sortable: true,
      minWidth: 170,
      flex: 1,
      cellStyle: { textAlign: "right", fontWeight: "500" },
      valueFormatter: (params) =>
        `₹ ${params.value?.toLocaleString("en-IN", { minimumFractionDigits: 2 })}`,
    },
    {
      headerName: "Revenue Diff",
      field: "diffRevenue",
      filter: true,
      sortable: true,
      minWidth: 170,
      flex: 1,
      cellStyle: { textAlign: "right", fontWeight: "500" },
      valueFormatter: (params) =>
        `₹ ${params.value?.toLocaleString("en-IN", { minimumFractionDigits: 2 })}`,
    },
    {
      headerName: "Net Revenue Impact",
      field: "netRevenueImpact",
      filter: true,
      sortable: true,
      minWidth: 200,
      flex: 1.5,
      cellStyle: { textAlign: "right", fontWeight: "500" },
      valueFormatter: (params) =>
        `₹ ${params.value?.toLocaleString("en-IN", { minimumFractionDigits: 2 })}`,
    },
    {
      headerName: "DSA Payout (%)",
      field: "dsaPayoutPercent",
      filter: true,
      sortable: true,
      minWidth: 160,
      flex: 1,
      cellStyle: { textAlign: "right", fontWeight: "500" },
      valueFormatter: (params) =>
        params.value !== undefined && params.value !== null ? `${params.value.toFixed(2)}%` : "",
    },
    {
      headerName: "Est. DSA Payout Amt",
      field: "estDSAPayoutAmt",
      filter: true,
      sortable: true,
      minWidth: 190,
      flex: 1.5,
      cellStyle: { textAlign: "right", fontWeight: "500" },
      valueFormatter: (params) =>
        `₹ ${params.value?.toLocaleString("en-IN", { minimumFractionDigits: 2 })}`,
    },
    {
      headerName: "Act. DSA Payout Paid",
      field: "actDSAPayoutPaid",
      filter: true,
      sortable: true,
      minWidth: 190,
      flex: 1.5,
      cellStyle: { textAlign: "right", fontWeight: "500" },
      valueFormatter: (params) =>
        `₹ ${params.value?.toLocaleString("en-IN", { minimumFractionDigits: 2 })}`,
    },
    {
      headerName: "Employee Name",
      field: "employeeName",
      filter: true,
      sortable: true,
      minWidth: 180,
      flex: 1.5,
    },
    {
      headerName: "Employee Code",
      field: "employeeCode",
      filter: true,
      sortable: true,
      minWidth: 160,
      flex: 1,
    },
    {
      headerName: "DSA Name",
      field: "dsaName",
      filter: true,
      sortable: true,
      minWidth: 180,
      flex: 1.5,
    },
    {
      headerName: "DSA Code",
      field: "dsaCode",
      filter: true,
      sortable: true,
      minWidth: 150,
      flex: 1,
    },
    {
      headerName: "Actual Month",
      field: "actualMonth",
      filter: true,
      sortable: true,
      minWidth: 140,
      flex: 1,
    },
    {
      headerName: "Source 1",
      field: "source1",
      filter: true,
      sortable: true,
      minWidth: 130,
      flex: 1,
    },
    {
      headerName: "Source 2",
      field: "source2",
      filter: true,
      sortable: true,
      minWidth: 130,
      flex: 1,
    },
    {
      headerName: "Provider Invoiced Amount",
      field: "providerInvoicedAmount",
      filter: true,
      sortable: true,
      minWidth: 200,
      flex: 1.5,
      cellStyle: { textAlign: "right", fontWeight: "500" },
      valueFormatter: (params) =>
        `₹ ${params.value?.toLocaleString("en-IN", { minimumFractionDigits: 2 })}`,
    },
    {
      headerName: "Provider TDS Amount",
      field: "providerAmount",
      filter: true,
      sortable: true,
      minWidth: 160,
      flex: 1,
      cellStyle: { textAlign: "right", fontWeight: "500" },
      valueFormatter: (params) =>
        `₹ ${params.value?.toLocaleString("en-IN", { minimumFractionDigits: 2 })}`,
    },
    {
      headerName: "Actual Received",
      field: "actualReceived",
      filter: true,
      sortable: true,
      minWidth: 160,
      flex: 1,
      cellStyle: { textAlign: "right", fontWeight: "500" },
      valueFormatter: (params) =>
        `₹ ${params.value?.toLocaleString("en-IN", { minimumFractionDigits: 2 })}`,
    },
    {
      headerName: "Provider Payout Status",
      field: "providerPayoutSttaus",
      filter: true,
      sortable: true,
      minWidth: 180,
      flex: 1.5,
      cellRenderer: (params) => {
        const status = params.value;
        const invoiceNo = params.data?.headOfficeInvoiceNo; // adjust field name as per your data

        const handleClick = () => {
          if (invoiceNo) {
            handlePrintKhInvoice(invoiceNo);
          } else {
            showAlert("Invoice number is missing", "error");
          }
        };

        const isReceived = status?.toLowerCase() === "received";
        const badgeColor = isReceived ? "#e6f0ff" : "#ffe6e6"; // blue or red background
        const textColor = isReceived ? "#1a73e8" : "#d93025"; // blue or red text

        return (
          <span
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              gap: "8px",
              height: "100%",
            }}
          >
            <span
              style={{
                backgroundColor: badgeColor,
                color: textColor,
                padding: "4px 10px",
                height: "30px",
                borderRadius: "12px",
                fontSize: "12px",
                fontWeight: 500,
                minWidth: "100px",
                textAlign: "center",
                display: params.value ? "flex" : "none",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
              }}
            >
              {params.value}
            </span>

            <Tooltip title="View Invoice">
              <button
                onClick={handleClick}
                style={{
                  display: invoiceNo ? "flex" : "none",
                  border: "none",
                  background: "transparent",
                  cursor: "pointer",
                  color: "#007bff",
                }}
              >
                <VisibilityIcon fontSize="medium" />
              </button>
            </Tooltip>
          </span>
        );
      },
    },
    {
      headerName: "Received",
      field: "providerReceivedAmount",
      filter: true,
      sortable: true,
      minWidth: 200,
      flex: 1.5,
      cellStyle: { textAlign: "right", fontWeight: "500" },
      valueFormatter: (params) =>
        params.value != null
          ? `₹ ${params.value.toLocaleString("en-IN", { minimumFractionDigits: 2 })}`
          : "",
    },
    {
      headerName: "Not Received",
      field: "providerNotReceivedAmount",
      filter: true,
      sortable: true,
      minWidth: 200,
      flex: 1.5,
      cellStyle: { textAlign: "right", fontWeight: "500" },
      valueFormatter: (params) =>
        params.value != null
          ? `₹ ${params.value.toLocaleString("en-IN", { minimumFractionDigits: 2 })}`
          : "",
    },
    {
      headerName: "DSA Invoiced Amount",
      field: "dsaInvoicedAmount",
      filter: true,
      sortable: true,
      minWidth: 190,
      flex: 1.5,
      cellStyle: { textAlign: "right", fontWeight: "500" },
      valueFormatter: (params) =>
        `₹ ${params.value?.toLocaleString("en-IN", { minimumFractionDigits: 2 })}`,
    },
    {
      headerName: "DSA TDS Amount",
      field: "dsaTdsAmount",
      filter: true,
      sortable: true,
      minWidth: 160,
      flex: 1,
      cellStyle: { textAlign: "right", fontWeight: "500" },
      valueFormatter: (params) =>
        `₹ ${params.value?.toLocaleString("en-IN", { minimumFractionDigits: 2 })}`,
    },
    {
      headerName: "Actual Transaction Amount",
      field: "actualTransactionAmount",
      filter: true,
      sortable: true,
      minWidth: 200,
      flex: 1.5,
      cellStyle: { textAlign: "right", fontWeight: "500" },
      valueFormatter: (params) =>
        `₹ ${params.value?.toLocaleString("en-IN", { minimumFractionDigits: 2 })}`,
    },
    {
      headerName: "DMA Payout Status",
      field: "dmaPayoutStatus",
      filter: true,
      sortable: true,
      minWidth: 180,
      flex: 1.5,
      cellRenderer: (params) => {
        const invoiceNo = params.data?.dsaInvoiceNo;
        const status = params.value;

        const handleClick = () => {
          if (invoiceNo) {
            handlePrintInvoice(invoiceNo);
          } else {
            showAlert("Invoice number is missing", "error");
          }
        };

        const isPaid = status?.toLowerCase() === "paid";
        const badgeColor = isPaid ? "#e6f0ff" : "#ffe6e6";
        const textColor = isPaid ? "#1a73e8" : "#d93025";

        return (
          <span
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              gap: "8px",
              height: "100%",
            }}
          >
            <span
              style={{
                backgroundColor: badgeColor,
                color: textColor,
                padding: "4px 10px",
                height: "30px",
                borderRadius: "12px",
                fontSize: "12px",
                fontWeight: 500,
                minWidth: "70px",
                textAlign: "center",
                display: params.value ? "flex" : "none",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
              }}
            >
              {params.value}
            </span>

            <Tooltip title="View Invoice">
              <button
                onClick={handleClick}
                style={{
                  display: invoiceNo ? "flex" : "none",
                  border: "none",
                  background: "transparent",
                  cursor: "pointer",
                  color: "#007bff",
                }}
              >
                <VisibilityIcon fontSize="medium" />
              </button>
            </Tooltip>
          </span>
        );
      },
    },
    {
      headerName: "Connector Payout",
      field: "subDSAPaymentAmount",
      filter: true,
      sortable: true,
      minWidth: 180,
      flex: 1.5,
      cellStyle: { textAlign: "right", fontWeight: "500" },
      valueFormatter: (params) =>
        params.value != null
          ? `₹ ${params.value.toLocaleString("en-IN", { minimumFractionDigits: 2 })}`
          : "",
    },
    {
      headerName: "Paid",
      field: "paidAmount",
      filter: true,
      sortable: true,
      minWidth: 180,
      flex: 1.5,
      cellStyle: { textAlign: "right", fontWeight: "500" },
      valueFormatter: (params) =>
        params.value != null
          ? `₹ ${params.value.toLocaleString("en-IN", { minimumFractionDigits: 2 })}`
          : "",
    },
    {
      headerName: "Not Paid",
      field: "notPaidAmount",
      filter: true,
      sortable: true,
      minWidth: 180,
      flex: 1.5,
      cellStyle: { textAlign: "right", fontWeight: "500" },
      valueFormatter: (params) =>
        params.value != null
          ? `₹ ${params.value.toLocaleString("en-IN", { minimumFractionDigits: 2 })}`
          : "",
    },
    {
      headerName: "kH Profit",
      field: "khProfit",
      filter: true,
      pinned: "right",
      sortable: true,
      minWidth: 200,
      flex: 1.5,
      cellStyle: { textAlign: "right", fontWeight: "500" },
      valueFormatter: (params) =>
        params.value != null
          ? `₹ ${params.value.toLocaleString("en-IN", { minimumFractionDigits: 2 })}`
          : "",
    },
  ];
  const childGridColDefs = [
    {
      headerName: "Banker Name",
      field: "bankerName",
      filter: true,
      sortable: true,
      minWidth: 250,
      flex: 1,
    },
    {
      headerName: "Application Number",
      field: "applicationNumber",
      filter: true,
      sortable: true,
      minWidth: 200,
      flex: 1.5,
    },
    {
      headerName: "headOfiiceInvoiceSerialNumber",
      field: "headOfiiceInvoiceSerialNumber",
      filter: true,
      sortable: true,
      minWidth: 200,
      flex: 1.5,
    },
    {
      headerName: "Customer Name",
      field: "customerName",
      filter: true,
      sortable: true,
      minWidth: 180,
      flex: 1.5,
    },
    {
      headerName: "Date",
      field: "date",
      filter: true,
      sortable: true,
      minWidth: 130,
      flex: 1,
    },
    {
      headerName: "Disbursement",
      field: "actualDisbursement",
      filter: true,
      sortable: true,
      minWidth: 200,
      flex: 1.5,
      cellStyle: { textAlign: "right", fontWeight: "500" },
      valueFormatter: (params) =>
        `₹ ${params.value?.toLocaleString("en-IN", { minimumFractionDigits: 2 })}`,
    },
    {
      headerName: "Gross Payout",
      field: "actualRevenue",
      filter: true,
      sortable: true,
      minWidth: 180,
      flex: 1.5,
      cellRenderer: (params) => {
        const amount = params.value;
        const status = params.data?.providerPayoutSttaus; // Adjust field name as per your data
        const invoiceNo = params.data?.headOfficeInvoiceNo; // Adjust field name as per your data

        const handleClick = () => {
          if (invoiceNo) {
            handlePrintKhInvoice(invoiceNo); // Function to fetch and display invoice
          } else {
            showAlert("Invoice number is missing", "error");
          }
        };
        let textColor;
        if (status?.toLowerCase() === "received" && invoiceNo) {
          textColor = "#27ae60"; // Darker green for Received with invoice
        } else if (status?.toLowerCase() === "not received" && invoiceNo) {
          textColor = "#d4ac0d"; // Deeper gold/yellow for Not Received with invoice
        } else {
          textColor = "#1c2833"; // Very dark slate for Not Received with no invoice
        }

        return (
          <Tooltip title={invoiceNo ? "View Invoice" : ""} disableInteractive={!invoiceNo}>
            <span
              style={{
                color: textColor,
                cursor: invoiceNo ? "pointer" : "default",
                border: invoiceNo ? `1px solid ${textColor}` : "none", // Subtle border for hover effect
                borderRadius: "7px", // Rounded corners for modern look
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                height: "100%",
                padding: "0 8px", // Improved touch target
                fontFamily:
                  "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif", // Modern font stack
                fontSize: "14px", // Clean and readable
                fontWeight: "bold",
                transition: "color 0.2s ease, transform 0.1s ease", // Smooth transitions
                transform: invoiceNo ? "scale(1)" : "none", // Base scale for hover effect
              }}
              onClick={invoiceNo ? handleClick : null}
              onMouseEnter={(e) => {
                if (invoiceNo) e.target.style.transform = "scale(1.02)"; // Subtle scale on hover
                if (invoiceNo) e.target.style.textDecoration = "underline"; // Underline on hover
              }}
              onMouseLeave={(e) => {
                if (invoiceNo) e.target.style.transform = "scale(1)";
                if (invoiceNo) e.target.style.textDecoration = "none";
              }}
            >
              {`₹ ${amount?.toLocaleString("en-IN", { minimumFractionDigits: 2 })}`}
            </span>
          </Tooltip>
        );
      },
    },
    {
      headerName: "DSA Payout",
      field: "actDSAPayoutPaid",
      filter: true,
      sortable: true,
      minWidth: 180,
      flex: 1.5,
      cellRenderer: (params) => {
        const amount = params.value;
        const status = params.data?.dmaPayoutStatus; // Adjust field name as per your data
        const invoiceNo = params.data?.dsaInvoiceNo; // Adjust field name as per your data

        const handleClick = () => {
          if (invoiceNo) {
            handlePrintInvoice(invoiceNo);
          } else {
            showAlert("Invoice number is missing", "error");
          }
        };
        let textColor;
        if (status?.toLowerCase() === "paid" && invoiceNo) {
          textColor = "#27ae60"; // Darker green for Received with invoice
        } else if (status?.toLowerCase() === "not paid" && invoiceNo) {
          textColor = "#d4ac0d"; // Deeper gold/yellow for Not Received with invoice
        } else {
          textColor = "#1c2833"; // Very dark slate for Not Received with no invoice
        }

        return (
          <Tooltip title={invoiceNo ? "View Invoice" : ""} disableInteractive={!invoiceNo}>
            <span
              style={{
                color: textColor,
                cursor: invoiceNo ? "pointer" : "default",
                border: invoiceNo ? `1px solid ${textColor}` : "none", // Subtle border for hover effect
                borderRadius: "7px", // Rounded corners for modern look
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                height: "100%",
                padding: "0 8px", // Improved touch target
                fontFamily:
                  "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif", // Modern font stack
                fontSize: "14px", // Clean and readable
                fontWeight: "bold",
                transition: "color 0.2s ease, transform 0.1s ease", // Smooth transitions
                transform: invoiceNo ? "scale(1)" : "none", // Base scale for hover effect
              }}
              onClick={invoiceNo ? handleClick : null}
              onMouseEnter={(e) => {
                if (invoiceNo) e.target.style.transform = "scale(1.02)"; // Subtle scale on hover
                if (invoiceNo) e.target.style.textDecoration = "underline"; // Underline on hover
              }}
              onMouseLeave={(e) => {
                if (invoiceNo) e.target.style.transform = "scale(1)";
                if (invoiceNo) e.target.style.textDecoration = "none";
              }}
            >
              {`₹ ${amount?.toLocaleString("en-IN", { minimumFractionDigits: 2 })}`}
            </span>
          </Tooltip>
        );
      },
    },
    {
      headerName: "Connector Payout",
      field: "subDSAPaymentAmount",
      filter: true,
      sortable: true,
      minWidth: 180,
      flex: 1.5,
      cellStyle: { textAlign: "right", fontWeight: "500" },
      valueFormatter: (params) =>
        params.value != null
          ? `₹ ${params.value.toLocaleString("en-IN", { minimumFractionDigits: 2 })}`
          : "",
    },
    {
      headerName: "Est kH Profit",
      field: "khProfit",
      pinned: "right",
      filter: "agNumberColumnFilter", // Optional: Use number filter for numeric data
      sortable: true,
      width: 130, // Set fixed width instead of flex for consistency
      maxWidth: 130,
      cellStyle: { textAlign: "right", fontWeight: "500" },
      valueFormatter: (params) =>
        params.data &&
        params.data.actualRevenue != null &&
        params.data.subDSAPaymentAmount != null &&
        params.data.actDSAPayoutPaid != null
          ? `₹ ${(
              params.data.actualRevenue -
              params.data.subDSAPaymentAmount -
              params.data.actDSAPayoutPaid
            ).toLocaleString("en-IN", { minimumFractionDigits: 2 })}`
          : "",
    },
  ];
  const FEW_FIELDS = [
    "date",
    "applicationNumber",
    "actualDisbursement",
    "dmaPayoutStatus",
    "paidAmount",
    "notPaidAmount",
    "balance",
    "actualRevenue",
    "khProfit",
    "balanceT",
    "actDSAPayoutPaid",
    "providerPayoutSttaus",
    "providerReceivedAmount",
    "providerNotReceivedAmount",
  ];
  const displayedColumnDefs = useMemo(() => {
    if (isFullView) {
      return ALL_COLUMN_DEFS;
    } else {
      return ALL_COLUMN_DEFS.filter((col) => FEW_FIELDS.includes(col.field));
    }
  }, [isFullView]);
  const onToggleView = () => {
    setIsFullView((prev) => !prev);
  };
  useEffect(() => {
    const calculateFooterData = () => {
      const total = childGridData.reduce(
        (acc, row) => {
          acc.appliedAmount += row.appliedAmount || 0;
          acc.netDisbursement += row.netDisbursement || 0;
          acc.actualDisbursement += row.actualDisbursement || 0;
          acc.estimateRevenue += row.estimateRevenue || 0;
          acc.actualRevenue += row.actualRevenue || 0;
          acc.diffDisb += row.diffDisb || 0;
          acc.diffRevenue += row.diffRevenue || 0;
          acc.netRevenueImpact += row.netRevenueImpact || 0;
          acc.estDSAPayoutAmt += row.estDSAPayoutAmt || 0;
          acc.actDSAPayoutPaid += row.actDSAPayoutPaid || 0;
          acc.dsaInvoicedAmount += row.dsaInvoicedAmount || 0;
          acc.dsaTdsAmount += row.dsaTdsAmount || 0;
          acc.providerInvoicedAmount += row.providerInvoicedAmount || 0;
          acc.providerAmount += row.providerAmount || 0;
          acc.actualReceived += row.actualReceived || 0;
          acc.actualTransactionAmount += row.actualTransactionAmount || 0;
          acc.subDSAPaymentAmount += row.subDSAPaymentAmount || 0;
          if (typeof row.paidAmount === "number" && !isNaN(row.paidAmount)) {
            acc.paidAmount += row.paidAmount;
          }
          // Same for row.notPaidAmount:
          if (typeof row.notPaidAmount === "number" && !isNaN(row.notPaidAmount)) {
            acc.notPaidAmount += row.notPaidAmount;
          }
          // And for providerReceivedAmount:
          if (
            typeof row.providerReceivedAmount === "number" &&
            !isNaN(row.providerReceivedAmount)
          ) {
            acc.providerReceivedAmount += row.providerReceivedAmount;
          }
          // And providerNotReceivedAmount:
          if (
            typeof row.providerNotReceivedAmount === "number" &&
            !isNaN(row.providerNotReceivedAmount)
          ) {
            acc.providerNotReceivedAmount += row.providerNotReceivedAmount;
          }

          return acc;
        },
        {
          appliedAmount: 0,
          netDisbursement: 0,
          actualDisbursement: 0,
          estimateRevenue: 0,
          actualRevenue: 0,
          diffDisb: 0,
          diffRevenue: 0,
          subDSAPaymentAmount: 0,
          netRevenueImpact: 0,
          estDSAPayoutAmt: 0,
          actDSAPayoutPaid: 0,
          dsaInvoiceNo: 0,
          headOfficeInvoiceNo: 0,
          dsaInvoicedAmount: 0,
          dsaTdsAmount: 0,
          providerInvoicedAmount: 0,
          providerAmount: 0,
          actualReceived: 0,
          actualTransactionAmount: 0,
          paidAmount: 0,
          notPaidAmount: 0,
          providerReceivedAmount: 0,
          providerNotReceivedAmount: 0,
        }
      );
      setFooterChildGridData([
        {
          remarks: "Total",
          ...total,
          // (a) compute balance = notPaidAmount - paidAmount
          balance: total.notPaidAmount - total.paidAmount,

          // (b) compute balanceT = providerNotReceivedAmount - providerReceivedAmount
          balanceT: total.providerNotReceivedAmount - total.providerReceivedAmount,

          // (c) compute khProfit = providerReceivedAmount - paidAmount
          khProfit: total.providerReceivedAmount - total.paidAmount,
          footerRow: true,
          estNetPercent: null,
          actNetPercent: null,
          dsaPayoutPercent: null,
          dsaInvoiceNo: null,
          headOfficeInvoiceNo: null,
          dsaInvoiceSerialNumber: null,
          headOfficeInvoiceSerialNumber: null,
          providerPayoutStatus: null,
          dmaPayoutStatus: null,
          reportMonth: null,
          bankerName: null,
          applicationNumber: null,
          date: null,
          product: null,
          customerName: null,
          employeeName: null,
          employeeCode: null,
          dsaName: null,
          dsaCode: null,
          actualMonth: null,
          source1: null,
          source2: null,
        },
      ]);
    };

    calculateFooterData();
  }, [childGridData]);
  useEffect(() => {
    setRowData(filteredData); // Update rowData
    const calculateFooterData = () => {
      const total = filteredData.reduce(
        (acc, row) => {
          acc.appliedAmount += row.appliedAmount || 0;
          acc.netDisbursement += row.netDisbursement || 0;
          acc.actualDisbursement += row.actualDisbursement || 0;
          acc.estimateRevenue += row.estimateRevenue || 0;
          acc.actualRevenue += row.actualRevenue || 0;
          acc.diffDisb += row.diffDisb || 0;
          acc.diffRevenue += row.diffRevenue || 0;
          acc.netRevenueImpact += row.netRevenueImpact || 0;
          acc.estDSAPayoutAmt += row.estDSAPayoutAmt || 0;
          acc.actDSAPayoutPaid += row.actDSAPayoutPaid || 0;
          acc.dsaInvoicedAmount += row.dsaInvoicedAmount || 0;
          acc.dsaTdsAmount += row.dsaTdsAmount || 0;
          acc.providerInvoicedAmount += row.providerInvoicedAmount || 0;
          acc.providerAmount += row.providerAmount || 0;
          acc.actualReceived += row.actualReceived || 0;
          acc.actualTransactionAmount += row.actualTransactionAmount || 0;
          acc.subDSAPaymentAmount += row.subDSAPaymentAmount || 0;
          if (typeof row.paidAmount === "number" && !isNaN(row.paidAmount)) {
            acc.paidAmount += row.paidAmount;
          }
          // Same for row.notPaidAmount:
          if (typeof row.notPaidAmount === "number" && !isNaN(row.notPaidAmount)) {
            acc.notPaidAmount += row.notPaidAmount;
          }
          // And for providerReceivedAmount:
          if (
            typeof row.providerReceivedAmount === "number" &&
            !isNaN(row.providerReceivedAmount)
          ) {
            acc.providerReceivedAmount += row.providerReceivedAmount;
          }
          // And providerNotReceivedAmount:
          if (
            typeof row.providerNotReceivedAmount === "number" &&
            !isNaN(row.providerNotReceivedAmount)
          ) {
            acc.providerNotReceivedAmount += row.providerNotReceivedAmount;
          }

          return acc;
        },
        {
          appliedAmount: 0,
          netDisbursement: 0,
          actualDisbursement: 0,
          estimateRevenue: 0,
          actualRevenue: 0,
          diffDisb: 0,
          subDSAPaymentAmount: 0,
          diffRevenue: 0,
          netRevenueImpact: 0,
          estDSAPayoutAmt: 0,
          actDSAPayoutPaid: 0,
          dsaInvoiceNo: 0,
          headOfficeInvoiceNo: 0,
          dsaInvoicedAmount: 0,
          dsaTdsAmount: 0,
          providerInvoicedAmount: 0,
          providerAmount: 0,
          actualReceived: 0,
          actualTransactionAmount: 0,
          paidAmount: 0,
          notPaidAmount: 0,
          providerReceivedAmount: 0,
          providerNotReceivedAmount: 0,
        }
      );

      setFooterData([
        {
          remarks: "Total",
          ...total,

          // (a) compute balance = notPaidAmount - paidAmount
          balance: total.notPaidAmount - total.paidAmount,

          // (b) compute balanceT = providerNotReceivedAmount - providerReceivedAmount
          balanceT: total.providerNotReceivedAmount - total.providerReceivedAmount,

          // (c) compute khProfit = providerReceivedAmount - paidAmount
          khProfit: total.providerReceivedAmount - total.paidAmount,
          footerRow: true,
          estNetPercent: null,
          actNetPercent: null,
          dsaPayoutPercent: null,
          dsaInvoiceNo: null,
          headOfficeInvoiceNo: null,
          dsaInvoiceSerialNumber: null,
          headOfficeInvoiceSerialNumber: null,
          providerPayoutStatus: null,
          dmaPayoutStatus: null,
          reportMonth: null,
          bankerName: null,
          applicationNumber: null,
          date: null,
          product: null,
          customerName: null,
          employeeName: null,
          employeeCode: null,
          dsaName: null,
          dsaCode: null,
          actualMonth: null,
          source1: null,
          source2: null,
        },
      ]);
    };

    calculateFooterData();
  }, [filteredData, servicesData]);
  useEffect(() => {
    const calculateDSAFooter = () => {
      const total = dsaBusiness.reduce(
        (acc, row) => {
          acc.business += row.business || 0;
          acc.grossPayout += row.grossPayout || 0;
          acc.dsaPayout += row.dsaPayout || 0;
          acc.expenditure += row.expenditure || 0;
          acc.netIncome += row.netIncome || 0;
          acc.subDsaPayments += row.subDsaPayments || 0;
          return acc;
        },
        {
          business: 0,
          subDsaPayments: 0,
          grossPayout: 0,
          dsaPayout: 0,
          expenditure: 0,
          netIncome: 0,
        }
      );

      setDsaFooterData([
        {
          dsaName: "Total",
          dsaId: "",
          ...total,
          footerRow: true,
        },
      ]);
    };

    calculateDSAFooter();
  }, [dsaBusiness]);
  const dsaBusinessColDefs = [
    { headerName: "DSA Name", field: "dsaName", pinned: "left", flex: 1 },
    {
      headerName: "Business",
      field: "business",
      flex: 1,
      cellStyle: { textAlign: "right", fontWeight: "500" },
      valueFormatter: (params) =>
        `₹ ${params.value?.toLocaleString("en-IN", { minimumFractionDigits: 2 })}`,
    },
    {
      headerName: "Gross Payout",
      field: "grossPayout",
      flex: 1,
      cellStyle: { textAlign: "right", fontWeight: "500" },
      valueFormatter: (params) =>
        `₹ ${params.value?.toLocaleString("en-IN", { minimumFractionDigits: 2 })}`,
    },
    {
      headerName: "DSA Payout",
      field: "dsaPayout",
      flex: 1,
      cellStyle: { textAlign: "right", fontWeight: "500" },
      valueFormatter: (params) =>
        `₹ ${params.value?.toLocaleString("en-IN", { minimumFractionDigits: 2 })}`,
    },
    {
      headerName: "Connector Payout",
      field: "subDsaPayments",
      flex: 1,
      cellStyle: { textAlign: "right", fontWeight: "500" },
      valueFormatter: (params) =>
        `₹ ${params.value?.toLocaleString("en-IN", { minimumFractionDigits: 2 })}`,
    },
    // {
    //   headerName: "Expenditure",
    //   field: "expenditure",
    //   flex: 1,
    //   cellStyle: { textAlign: "right", fontWeight: "500" },
    //   cellRenderer: ExpenditureCellRenderer,
    //   cellRendererParams: {
    //     onEyeClick: (dsaId) => {
    //       setDsaId(dsaId);
    //       setExpenseIsOpen(true);
    //     },
    //   },
    // },
    // {
    //   headerName: "Net Income",
    //   field: "netIncome",
    //   flex: 1,
    //   cellStyle: { textAlign: "right", fontWeight: "500" },
    //   valueFormatter: (params) =>
    //     `₹ ${params.value?.toLocaleString("en-IN", { minimumFractionDigits: 2 })}`,
    // },
    {
      headerName: "Actions",
      field: "actions",
      flex: 0.5,
      cellRenderer: (params) => {
        if (params.data?.footerRow) return null;

        return (
          <>
            <Tooltip title="View" arrow>
              <IconButton type="button" onClick={() => handleViewClick(params)} color="primary">
                <VisibilityIcon />
              </IconButton>
            </Tooltip>
          </>
        );
      },
    },
  ];
  const fetchChildGridData = useCallback(
    async (dsaId) => {
      if (startDate && endDate) {
        const formattedStartDate = dayjs(startDate).format("YYYY-MM-DD");
        const formattedEndDate = dayjs(endDate).format("YYYY-MM-DD");
        setLoading(true);
        try {
          const options = {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${jwt_token}`,
            },
          };
          const responseA = await fetch(
            `${URLs.pAndLByDsaId}?startDate=${formattedStartDate}&endDate=${formattedEndDate}&dsaId=${dsaId}`,
            options
          );
          const dataA = await responseA.json();

          if (responseA.ok) {
            setChildGridData([...dataA]);
          } else {
            throw new Error("Failed to fetch entries data");
          }
        } catch (error) {
          showAlert(`Failed to fetch data: ${error.message}`, "error");
        } finally {
          setLoading(false);
        }
      } else {
        showAlert("Please select both start and end dates", "error");
      }
    },
    [selectedDSA]
  );
  const fetchReceivableData = useCallback(async () => {
    if (startDate && endDate) {
      const formattedStartDate = dayjs(startDate).format("YYYY-MM-DD");
      const formattedEndDate = dayjs(endDate).format("YYYY-MM-DD");
      setLoading(true);
      try {
        const options = {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${jwt_token}`,
          },
        };
        const responseA = await fetch(
          `${URLs.dsaReceivablesKh}?startDate=${formattedStartDate}&endDate=${formattedEndDate}`,
          options
        );
        const dataA = await responseA.json();

        const responseB = await fetch(
          `${URLs.dsaReceivables}?startDate=${formattedStartDate}&endDate=${formattedEndDate}`,
          options
        );
        const dataB = await responseB.json();
        if (responseA.ok) {
          setDsaReceivables([...dataA, ...dataB]);
        } else {
          throw new Error("Failed to fetch entries data");
        }
      } catch (error) {
        showAlert(`Failed to fetch data: ${error.message}`, "error");
      } finally {
        setLoading(false);
      }
    } else {
      showAlert("Please select both start and end dates", "error");
    }
  });
  const handleViewClick = (params) => {
    setPopoverOpen(true);
    setSelectedDSA(params.data.dsaId);
    fetchChildGridData(params.data.dsaId);
  };
  const closePopover = () => {
    setPopoverOpen(false);
    setSelectedDSA(null);
    setChildGridData([]);
  };
  const receivableColdefs = [
    {
      headerName: "DSA Name",
      field: "dsaName",
      minWidth: 200,
      pinned: "left",
      cellClass: "fw-600",
    },
    {
      headerName: "Revenue",
      field: "invoiceTotal",
      minWidth: 150,
      flex: 1,
      cellStyle: { textAlign: "right", fontWeight: "500" },
      valueFormatter: (params) =>
        `₹ ${params.value?.toLocaleString("en-IN", { minimumFractionDigits: 2 })}`,
      cellClass: "text-end",
    },
    {
      headerName: "Total GST",
      field: "totalGST",
      minWidth: 150,
      flex: 1,
      cellStyle: { textAlign: "right", fontWeight: "500" },
      valueFormatter: (params) =>
        `₹ ${params.value?.toLocaleString("en-IN", { minimumFractionDigits: 2 })}`,
      cellClass: "text-end",
    },
    {
      headerName: "Invoiced Amount",
      field: "invoicedAmount",
      minWidth: 160,
      flex: 1,
      cellStyle: { textAlign: "right", fontWeight: "500" },
      valueFormatter: (params) =>
        `₹ ${params.value?.toLocaleString("en-IN", { minimumFractionDigits: 2 })}`,
      cellClass: "text-end",
    },
    {
      headerName: "Received Amount",
      field: "receivedAmount",
      minWidth: 160,
      flex: 1,
      cellStyle: { textAlign: "right", fontWeight: "500" },
      valueFormatter: (params) =>
        `₹ ${params.value?.toLocaleString("en-IN", { minimumFractionDigits: 2 })}`,
      cellClass: "text-end",
    },
    {
      headerName: "Balance Amount",
      field: "balanceAmount",
      flex: 1,
      cellStyle: { textAlign: "right", fontWeight: "500" },
      minWidth: 160,
      valueFormatter: (params) =>
        `₹ ${params.value?.toLocaleString("en-IN", { minimumFractionDigits: 2 })}`,
      cellClass: "text-end",
    },
  ];

  useEffect(() => {
    if (activeTab === 1) {
      fetchEntriesByDSAMonthId();
      fetchReceivableData();
      fetchReceivablesWithoutDateRangeData();
      fetcNotInvoicedData();
    }
  }, [activeTab]);

  useEffect(() => {
    const calculateReceivableFooter = () => {
      const total = dsaReceivables.reduce(
        (acc, row) => {
          acc.invoiceTotal += row.invoiceTotal || 0;
          acc.totalGST += row.totalGST || 0;
          acc.invoicedAmount += row.invoicedAmount || 0;
          acc.receivedAmount += row.receivedAmount || 0;
          acc.balanceAmount += row.balanceAmount || 0;
          acc.txnCount += row.txnCount || 0;
          return acc;
        },
        {
          invoiceTotal: 0,
          totalGST: 0,
          invoicedAmount: 0,
          receivedAmount: 0,
          balanceAmount: 0,
          txnCount: 0,
        }
      );

      setReceivableFooterData([
        {
          dsaName: "Total",
          dsaId: "",
          ...total,
          footerRow: true,
        },
      ]);
    };

    calculateReceivableFooter();
  }, [dsaReceivables]);

  const ViewBalanceCellRenderer = (props) => {
    const isFooter = props.data?.footerRow;
    const handleClick = async () => {
      const dsaId = props.data?.dsaId;
      setHighlightAllRowsInv(dsaId);
      setLoading(true);
      if (dsaId == undefined || null) return;
      const url = dsaId
        ? `${URLs.receivableAgainstDsa}?dsaId=${dsaId}`
        : `${URLs.receivableAgainstDsaKh}?dsaId=${dsaId}`;
      try {
        const response = await fetch(url, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${jwt_token}`, // if needed
          },
        });

        if (!response.ok) {
          throw new Error("Failed to fetch DSA details");
        }

        const data = await response.json();
        setRecievablesAgtInvData(data);
      } catch (error) {
        console.error("API call error:", error.message);
      }
      setLoading(false);
    };

    return (
      <div className="flex justify-between items-center pr-2">
        <span>{props.valueFormatted}</span>
        {isFooter ? null : (
          <IconButton onClick={handleClick} size="small" sx={{ ml: 1 }}>
            <VisibilityIcon fontSize="medium" />
          </IconButton>
        )}
      </div>
    );
  };
  ViewBalanceCellRenderer.propTypes = {
    data: PropTypes.object,
    valueFormatted: PropTypes.any,
  };
  const ViewInvCellRenderer = (props) => {
    const isFooter = props.data?.footerRow;
    const handleClick = async () => {
      const invNo = props.data?.invoiceNo;
      const dsaId = props.data?.dsaId;

      if (invNo === undefined || invNo === null) return;

      if (dsaId === 0) {
        console.log("Printing invoice for DSA ID 0");
        handlePrintKhInvoice(invNo);
      } else {
        console.log("Printing invoice for DSA ID:", dsaId);
        handlePrintInvoice(invNo);
      }
    };

    return (
      <div className="flex justify-between items-center pr-2">
        <span>{props.value}</span> {/* Use props.value instead of props.invoiceDisplayNumber */}
        {isFooter ? null : (
          <IconButton onClick={handleClick} size="small" sx={{ ml: 1 }}>
            <VisibilityIcon fontSize="medium" />
          </IconButton>
        )}
      </div>
    );
  };

  ViewInvCellRenderer.propTypes = {
    data: PropTypes.object,
    value: PropTypes.any, // value instead of valueFormatted
  };

  const recievablesAgainstInvoice = [
    {
      headerName: "DSA Name",
      field: "dsaName",
      minWidth: 200,
      pinned: "left",
      cellClass: "fw-600",
    },
    {
      headerName: "Balance",
      field: "balanceAmount",
      minWidth: 150,
      flex: 1,
      cellStyle: { textAlign: "right", fontWeight: "500" },
      valueFormatter: (params) =>
        `₹ ${params.value?.toLocaleString("en-IN", { minimumFractionDigits: 2 })}`,
      cellRenderer: ViewBalanceCellRenderer, // Custom cell renderer
    },
  ];

  const recievablesAgtInvColDefs = [
    {
      headerName: "Invoice Display No",
      field: "invoiceDisplayNumber",
      minWidth: 200,
      cellClass: (params) => (params.data?.footerRow ? "fw-600" : ""),
      cellRenderer: ViewInvCellRenderer, // Custom cell renderer
    },
    {
      headerName: "Date",
      field: "date",
      minWidth: 160,
      valueFormatter: (params) => {
        if (!params.value) return "";
        const date = new Date(params.value);
        return date.toLocaleDateString("en-IN", {
          year: "numeric",
          month: "short",
          day: "numeric",
        });
      },
      cellClass: (params) => (params.data?.footerRow ? "fw-600" : ""),
    },
    {
      headerName: "Provider Name",
      field: "providerName",
      minWidth: 200,
      cellClass: (params) => (params.data?.footerRow ? "fw-600" : ""),
    },
    {
      headerName: "Total",
      field: "total",
      minWidth: 150,
      flex: 1,
      cellStyle: { textAlign: "right", fontWeight: "500" },
      valueFormatter: (params) =>
        typeof params.value === "number"
          ? `₹ ${params.value.toLocaleString("en-IN", {
              minimumFractionDigits: 2,
            })}`
          : "",
      cellClass: (params) => `text-end ${params.data?.footerRow ? "fw-600" : ""}`,
    },
    {
      headerName: "Balance",
      field: "balance",
      minWidth: 150,
      flex: 1,
      cellStyle: { textAlign: "right", fontWeight: "500" },
      valueFormatter: (params) =>
        typeof params.value === "number"
          ? `₹ ${params.value.toLocaleString("en-IN", {
              minimumFractionDigits: 2,
            })}`
          : "",
      cellClass: (params) => `text-end ${params.data?.footerRow ? "fw-600" : ""}`,
    },
  ];
  const fetchReceivablesWithoutDateRangeData = useCallback(async () => {
    setLoading(true);
    try {
      const response = await fetch(`${URLs.recivablesWithoutDateRange}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwt_token}`,
        },
      });
      const responseA = await fetch(`${URLs.recivableWithoutDateRangeKh}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwt_token}`,
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch entries data");
      }
      if (!responseA.ok) {
        throw new Error("Failed to fetch entries data");
      }

      const data = await response.json();
      const dataA = await responseA.json();
      setRecievablesAgainstInvoiceData([...data, ...dataA]);
    } catch (error) {
      showAlert(`Failed to fetch data: ${error.message}`, "error");
    } finally {
      setLoading(false);
    }
  }, [jwt_token]);

  useEffect(() => {
    const calculateReceivableFooter = () => {
      const total = recievablesAgainstInvoiceData.reduce(
        (acc, row) => {
          acc.invoiceTotal += row.invoiceTotal || 0;
          acc.totalGST += row.totalGST || 0;
          acc.invoicedAmount += row.invoicedAmount || 0;
          acc.receivedAmount += row.receivedAmount || 0;
          acc.balanceAmount += row.balanceAmount || 0;
          acc.txnCount += row.txnCount || 0;
          return acc;
        },
        {
          invoiceTotal: 0,
          totalGST: 0,
          invoicedAmount: 0,
          receivedAmount: 0,
          balanceAmount: 0,
          txnCount: 0,
        }
      );

      setRecievablesAgainstInvoiceFooterData([
        {
          dsaName: "Total",
          dsaId: "",
          ...total,
          footerRow: true,
        },
      ]);
    };

    calculateReceivableFooter();
  }, [recievablesAgainstInvoiceData]);

  useEffect(() => {
    const calculateInvoiceFooter = () => {
      const total = recievablesAgtInvData.reduce(
        (acc, row) => {
          acc.total += row.total || 0;
          acc.balance += row.balance || 0;
          return acc;
        },
        {
          total: 0,
          balance: 0,
        }
      );

      setRecievablesAgtInvfooterData([
        {
          invoiceNo: "",
          invoiceDisplayNumber: "",
          date: "",
          providerName: "Total",
          ...total,
          footerRow: true,
        },
      ]);
    };

    calculateInvoiceFooter();
  }, [recievablesAgtInvData]);

  const ViewNotInvCellRenderer = (props) => {
    const isFooter = props.data?.footerRow;
    const handleClick = async () => {
      const dsaId = props.data?.dsaId;
      const dsaName = props.data?.dsaName;
      setCompanyId(dsaId);
      setSelectedRange(30);
      setSelectedDSAName(dsaName);

      setLoading(true);
      const today = new Date();
      const past30 = new Date();
      past30.setDate(today.getDate() - 30);
      const startDate = past30.toISOString().split("T")[0];
      const endDate = today.toISOString().split("T")[0];
      const url = `${URLs.allPayoutsNotReceivableNotRaisedInvoice}/DateRange/${dsaId}?startDate=${startDate}&endDate=${endDate}`;

      try {
        const response = await fetch(url, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${jwt_token}`, // if needed
          },
        });

        if (!response.ok) {
          throw new Error("Failed to fetch DSA details");
        }

        const data = await response.json();
        setRecievablesNotInvData(data);
      } catch (error) {
        console.error("API call error:", error.message);
      }

      setLoading(false);
    };

    return (
      <div className="flex justify-between items-center pr-2">
        <span>{props.valueFormatted}</span>
        {!isFooter && (
          <IconButton onClick={handleClick} size="small" sx={{ ml: 1 }}>
            <VisibilityIcon fontSize="medium" />
          </IconButton>
        )}
      </div>
    );
  };

  ViewNotInvCellRenderer.propTypes = {
    data: PropTypes.object,
    valueFormatted: PropTypes.any,
  };

  const notRecievablesNaInvoice = [
    {
      headerName: "DSA Name",
      field: "dsaName",
      minWidth: 200,
      pinned: "left",
      cellClass: "fw-600",
    },
    {
      headerName: "Balance",
      field: "grossPayoutAmount",
      minWidth: 150,
      flex: 1,
      cellStyle: { textAlign: "right", fontWeight: "500" },
      valueFormatter: (params) =>
        `₹ ${params.value?.toLocaleString("en-IN", { minimumFractionDigits: 2 })}`,
      cellRenderer: ViewNotInvCellRenderer,
    },
  ];

  const recievablesNotInvColDefs = [
    {
      headerName: "Application Number",
      field: "applicationNumber",
      minWidth: 180,
      cellClass: "fw-600",
    },
    {
      headerName: "Date",
      field: "date",
      maxWidth: 120,
      valueFormatter: (params) => {
        const date = new Date(params.value);
        if (isNaN(date.getTime())) return ""; // Check for invalid date
        return date.toLocaleDateString("en-IN", {
          year: "numeric",
          month: "short",
          day: "numeric",
        });
      },
    },
    {
      headerName: "DSA Name",
      field: "dsaName",
      minWidth: 200,
    },
    {
      headerName: "Customer Name",
      field: "customerName",
      minWidth: 200,
    },
    {
      headerName: "Banker Name",
      field: "financialInstitutionName",
      minWidth: 220,
    },
    {
      headerName: "Disbursed Amount",
      field: "disbursedAmount",
      minWidth: 180,
      flex: 1,
      cellStyle: { textAlign: "right", fontWeight: "500" },
      valueFormatter: (params) =>
        `₹ ${params.value?.toLocaleString("en-IN", {
          minimumFractionDigits: 2,
        })}`,
      cellClass: "text-end",
    },
    {
      headerName: "Gross Payout Amount",
      field: "grossPayoutAmount",
      minWidth: 180,
      pinned: "right",
      flex: 1,
      cellStyle: { textAlign: "right", fontWeight: "500" },
      valueFormatter: (params) =>
        `₹ ${params.value?.toLocaleString("en-IN", {
          minimumFractionDigits: 2,
        })}`,
      cellClass: "text-end",
    },
  ];

  const fetcNotInvoicedData = useCallback(async () => {
    setLoading(true);
    try {
      const response = await fetch(`${URLs.receivableNotRaisedInvoices}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwt_token}`,
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch entries data");
      }

      const data = await response.json();
      setNotRecievablesNanvoiceData(data);
    } catch (error) {
      showAlert(`Failed to fetch data: ${error.message}`, "error");
    } finally {
      setLoading(false);
    }
  }, [jwt_token]);

  useEffect(() => {
    const calculateReceivableFooter = () => {
      const total = notRecievablesNanvoiceData.reduce(
        (acc, row) => {
          acc.grossPayoutAmount += row.grossPayoutAmount || 0;
          return acc;
        },
        {
          grossPayoutAmount: 0,
        }
      );

      setNotRecievablesAgainstInvoiceFooterData([
        {
          dsaName: "Total",
          dsaId: "",
          ...total,
          footerRow: true,
        },
      ]);
    };

    calculateReceivableFooter();
  }, [notRecievablesNanvoiceData]);

  useEffect(() => {
    const calculateInvoiceFooter = () => {
      const totals = recievablesNotInvData.reduce(
        (acc, row) => {
          acc.grossPayoutAmount += row.grossPayoutAmount || 0;
          acc.disbursedAmount += row.disbursedAmount || 0;
          return acc;
        },
        {
          grossPayoutAmount: 0,
          disbursedAmount: 0,
        }
      );

      setRecievablesNotInvfooterData([
        {
          applicationNumber: "",
          date: "TOTAL",
          customerName: "",
          financialInstitutionName: "",
          grossPayoutAmount: totals.grossPayoutAmount,
          disbursedAmount: totals.disbursedAmount,
          dsaName: "Total",
          footerRow: true,
        },
      ]);
    };

    calculateInvoiceFooter();
  }, [recievablesNotInvData]);

  const handleFilter = async ({ startDate, endDate, isAbove, all, allByCom }) => {
    setLoading(true);
    if (companyId === null || companyId === undefined) {
      showAlert("Please select a DSA first", "error");
      setLoading(false);
      return;
    }
    let url = `${URLs.allPayoutsNotReceivableNotRaisedInvoice}`;
    if (isAbove) {
      url += `/${companyId}/startDate?startDate=${endDate}`;
    } else if (allByCom) {
      url += `/${companyId}`;
    } else if (all) {
      url += `s`;
    } else {
      url += `/DateRange/${companyId}?startDate=${startDate}&endDate=${endDate}`;
    }

    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwt_token}`,
        },
      });

      if (!response.ok) throw new Error("API call failed");

      const data = await response.json();
      setRecievablesNotInvData(data);
    } catch (err) {
      console.error(err.message);
    }

    setLoading(false);
  };
  const handleDownloadExcel = () => {
    if (!recievablesNotInvData || recievablesNotInvData.length === 0) {
      showAlert("No data available to export", "warning");
      return;
    }

    // Convert data to worksheet
    const worksheet = XLSX.utils.json_to_sheet(recievablesNotInvData);

    // Auto width for all columns
    const colWidths = Object.keys(recievablesNotInvData[0]).map((key) => ({
      wch: Math.max(
        key.length,
        ...recievablesNotInvData.map((row) => (row[key] ? row[key].toString().length : 0))
      ),
    }));
    worksheet["!cols"] = colWidths;

    // Create workbook
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Receivables_Not_Invoiced");

    // Apply some basic header styling
    const headerRange = XLSX.utils.decode_range(worksheet["!ref"]);
    for (let C = headerRange.s.c; C <= headerRange.e.c; ++C) {
      const cellRef = XLSX.utils.encode_cell({ r: 0, c: C });
      if (worksheet[cellRef]) {
        worksheet[cellRef].s = {
          font: { bold: true, color: { rgb: "FFFFFF" } },
          fill: { fgColor: { rgb: "D46B08" } },
          alignment: { horizontal: "center" },
        };
      }
    }

    // Export as Excel file
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([excelBuffer], {
      type: "application/octet-stream",
    });
    saveAs(blob, `Account_Receivables_${dayjs().format("YYYYMMDD_HHmm")}.xlsx`);
  };

  return (
    <>
      <Dialog
        open={loading}
        onClose={() => setLoading(false)}
        aria-labelledby="loading-dialog-title"
      >
        <DialogContent style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
          <CircularProgress color="primary" />
          <Typography variant="h6" style={{ marginTop: "20px" }}>
            Loading, please wait...
          </Typography>
        </DialogContent>
      </Dialog>
      <StyledSnackbar
        open={open}
        autoHideDuration={5000}
        onClose={handleCloseAlert}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        severity={alertType}
      >
        <StyledAlert onClose={handleCloseAlert} severity={alertType}>
          {message}
        </StyledAlert>
      </StyledSnackbar>
      <Box sx={{ height: "1rem" }} />
      <ResponsiveTabs
        tabs={tabs}
        activeTab={activeTab}
        onChange={handleChange}
        labelColor="#ffffff"
        bgColor="#e0f7fa"
      />
      <Modal open={popoverOpen} onClose={closePopover}>
        <Box
          sx={{
            position: "absolute",
            top: "10vh",
            left: "5vw",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            width: "90vw",
            height: "90vh",
            bgcolor: "white",
            boxShadow: 24,
            p: 2,
            borderRadius: 2,
          }}
        >
          <StyledButton onClick={closePopover} sx={{ mb: 1 }}>
            <CloseIcon fontSize="medium" />
          </StyledButton>
          <StyledAgGridContainer
            component={Paper}
            className="ag-theme-alpine"
            sx={{ height: "50v", width: "100%" }}
          >
            <AgGridReact
              enableCellTextSelection={true}
              enableRangeSelection={true}
              columnDefs={childGridColDefs}
              rowData={childGridData}
              suppressClipboardPaste={false}
              pagination={true}
              defaultColDef={{
                filter: true, // Enable filters by default
                sortable: true, // Optional: enable sorting
                resizable: true, // Optional: resizable columns
                floatingFilter: true, // Optional: show filter input below header
              }}
              getRowStyle={(params) => {
                if (params.data?.disbursementStatus === "D") {
                  return { backgroundColor: "#b71c1c", color: "#fff" }; // Red background with white text for "D" status
                }
                return { backgroundColor: "#FFFFFF", color: "#1C2526" }; // Charcoal background with white text for other rows
              }}
              paginationPageSize={100}
              animateRows={true}
              pinnedBottomRowData={footerChildGridData}
            />
          </StyledAgGridContainer>
        </Box>
      </Modal>
      <TotalExpenditureStatement
        dsaId={dsaId}
        expenseIsOpen={expenseIsOpen}
        expenseOnClose={handleCloseModal}
        startDate={startDate}
        endDate={endDate}
      />
      {activeTab === 0 && (
        <TableContainer
          component={Paper}
          sx={{
            ...monthEndStyles.tableContainer,
            flex: 1,
            overflow: "auto",
            display: "flex",
            flexDirection: "column",
            height: "calc(100vh - 1rem)",
          }}
        >
          <Box sx={monthEndStyles.formContainer}>
            <Box sx={monthEndStyles.formItem}>
              <TextField
                label="Start Date"
                type="date"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
                sx={{ ...MInput.b, maxWidth: "140px" }}
                InputLabelProps={{
                  shrink: true,
                  sx: { color: MInput.a },
                }}
              />
              <TextField
                label="End Date"
                type="date"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
                sx={{ ...MInput.b, maxWidth: "140px" }}
                InputLabelProps={{
                  shrink: true,
                  sx: { color: MInput.a },
                }}
              />
              <StyledButton onClick={triggerApiCall}>Get</StyledButton>
              <StyledButton onClick={onToggleView} style={{ cursor: "pointer" }}>
                {isFullView ? "Compact View (Few Columns)" : "Full View (All Columns)"}
              </StyledButton>
            </Box>
            {ActionCellRenderer()}
          </Box>
          <StyledAgGridContainer
            component={Paper}
            className="ag-theme-alpine"
            sx={{ height: "80vh", width: "100%", marginBottom: "20px" }}
          >
            <AgGridReact
              enableCellTextSelection={true}
              enableRangeSelection={true}
              columnDefs={displayedColumnDefs}
              rowData={filteredData}
              suppressClipboardPaste={false}
              pagination={true}
              defaultColDef={{
                filter: true, // Enable filters by default
                sortable: true, // Optional: enable sorting
                resizable: true, // Optional: resizable columns
                floatingFilter: true, // Optional: show filter input below header
              }}
              getRowStyle={(params) => {
                if (params.data?.disbursementStatus === "D") {
                  return { backgroundColor: "#b71c1c", color: "#fff" }; // Red background with white text for "D" status
                }
                return { backgroundColor: "#FFFFFF", color: "#1C2526" }; // Charcoal background with white text for other rows
              }}
              paginationPageSize={100}
              pinnedBottomRowData={footerData}
              animateRows={true}
            />
          </StyledAgGridContainer>
        </TableContainer>
      )}
      {activeTab === 1 && (
        <Box
          component={Paper}
          sx={{
            mt: 2,
            p: 2,
            mb: 1,
            flex: 1,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Box sx={monthEndStyles.formContainer}>
            <Box sx={monthEndStyles.formItem}>
              <TextField
                label="Start Date"
                type="date"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
                sx={{ ...MInput.b, maxWidth: "140px" }}
                InputLabelProps={{
                  shrink: true,
                  sx: { color: MInput.a },
                }}
              />
              <TextField
                label="End Date"
                type="date"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
                sx={{ ...MInput.b, maxWidth: "140px" }}
                InputLabelProps={{
                  shrink: true,
                  sx: { color: MInput.a },
                }}
              />
              <StyledButton onClick={triggerApiDsaBCall}>Get</StyledButton>
            </Box>
          </Box>
          <ModernHeader label="Total KH business via DSAs & in-house" />
          <StyledAgGridContainer
            component={Paper}
            className="ag-theme-alpine"
            sx={{ minHeight: "500px", width: "100%", marginBottom: "20px" }}
          >
            <AgGridReact
              enableCellTextSelection={true}
              enableRangeSelection={true}
              columnDefs={dsaBusinessColDefs}
              rowData={dsaBusiness}
              suppressClipboardPaste={false}
              pagination={true}
              defaultColDef={{
                filter: true, // Enable filters by default
                sortable: true, // Optional: enable sorting
                resizable: true, // Optional: resizable columns
                floatingFilter: true, // Optional: show filter input below header
              }}
              paginationPageSize={100}
              pinnedBottomRowData={dsaFooterData}
              animateRows={true}
            />
          </StyledAgGridContainer>
          <ModernHeader label="Confirmed Business A/C MIS" />
          <StyledAgGridContainer
            component={Paper}
            className="ag-theme-alpine"
            sx={{ minHeight: "500px", width: "100%", marginBottom: "20px" }}
          >
            <AgGridReact
              enableCellTextSelection={true}
              enableRangeSelection={true}
              columnDefs={receivableColdefs}
              rowData={dsaReceivables}
              suppressClipboardPaste={false}
              pagination={true}
              defaultColDef={{
                filter: true, // Enable filters by default
                sortable: true, // Optional: enable sorting
                resizable: true, // Optional: resizable columns
                floatingFilter: true, // Optional: show filter input below header
              }}
              paginationPageSize={100}
              pinnedBottomRowData={receivableFooterData}
              animateRows={true}
            />
          </StyledAgGridContainer>
          <ModernHeader label="Account Receivables Against Invoice" />
          <Grid container spacing={2} sx={{ marginBottom: 2 }}>
            <Grid item xs={12} md={4}>
              <StyledAgGridContainer
                component={Paper}
                className="ag-theme-alpine"
                sx={{ height: "500px", width: "100%" }}
              >
                <AgGridReact
                  enableCellTextSelection={true}
                  enableRangeSelection={true}
                  columnDefs={recievablesAgainstInvoice}
                  rowData={recievablesAgainstInvoiceData}
                  suppressClipboardPaste={false}
                  pagination={true}
                  defaultColDef={{
                    filter: true, // Enable filters by default
                    sortable: true, // Optional: enable sorting
                    resizable: true, // Optional: resizable columns
                    floatingFilter: true, // Optional: show filter input below header
                  }}
                  paginationPageSize={100}
                  pinnedBottomRowData={recievablesAgainstInvoiceFooterData}
                  animateRows={true}
                  getRowStyle={(params) => {
                    const isFooter = params.data?.footerRow;

                    // Skip styling if this is the pinned footer row
                    if (isFooter) return null;

                    // Highlight if dsaId matches the selected highlightAllRowsInv
                    if (params.data?.dsaId === highlightAllRowsInv) {
                      return {
                        backgroundColor: "#D46B08",
                        color: "#fff",
                      };
                    }

                    return null;
                  }}
                />
              </StyledAgGridContainer>
            </Grid>
            <Grid item xs={12} md={8}>
              <StyledAgGridContainer
                component={Paper}
                className="ag-theme-alpine"
                sx={{ height: "500px", width: "100%" }}
              >
                <AgGridReact
                  enableCellTextSelection={true}
                  enableRangeSelection={true}
                  columnDefs={recievablesAgtInvColDefs}
                  rowData={recievablesAgtInvData}
                  suppressClipboardPaste={false}
                  pagination={true}
                  defaultColDef={{
                    filter: true, // Enable filters by default
                    sortable: true, // Optional: enable sorting
                    resizable: true, // Optional: resizable columns
                    floatingFilter: true, // Optional: show filter input below header
                  }}
                  paginationPageSize={100}
                  pinnedBottomRowData={recievablesAgtInvfooterData}
                  animateRows={true}
                />
              </StyledAgGridContainer>
            </Grid>
          </Grid>
          <ModernHeader label="Account Receivables but not raised Invoice" />
          <Grid container spacing={2} sx={{ marginBottom: 2 }}>
            <Grid item xs={12} md={4}>
              <StyledAgGridContainer
                component={Paper}
                className="ag-theme-alpine"
                sx={{ minHeight: "400px", width: "100%" }}
              >
                <AgGridReact
                  enableCellTextSelection={true}
                  enableRangeSelection={true}
                  columnDefs={notRecievablesNaInvoice}
                  rowData={notRecievablesNanvoiceData}
                  suppressClipboardPaste={false}
                  pagination={true}
                  defaultColDef={{
                    filter: true, // Enable filters by default
                    sortable: true, // Optional: enable sorting
                    resizable: true, // Optional: resizable columns
                    floatingFilter: true, // Optional: show filter input below header
                  }}
                  paginationPageSize={100}
                  pinnedBottomRowData={notRecievablesAgainstInvoiceFooterData}
                  animateRows={true}
                  getRowStyle={(params) => {
                    if (highlightAllRows) {
                      return { backgroundColor: "#FFF3E0" }; // Light orange background
                    }
                    if (params.data?.dsaId === companyId) {
                      return { backgroundColor: "#D46B08", color: "#fff" }; // Highlight specific DSA
                    }
                    return null;
                  }}
                />
              </StyledAgGridContainer>
            </Grid>
            <Grid item xs={12} md={8}>
              <DaysFilterButtons onFilter={handleFilter} onDownload={handleDownloadExcel} />
              <StyledAgGridContainer
                component={Paper}
                className="ag-theme-alpine"
                sx={{ height: "500px", width: "100%" }}
              >
                <AgGridReact
                  enableCellTextSelection={true}
                  enableRangeSelection={true}
                  columnDefs={recievablesNotInvColDefs}
                  rowData={recievablesNotInvData}
                  suppressClipboardPaste={false}
                  defaultColDef={{
                    filter: true, // Enable filters by default
                    sortable: true, // Optional: enable sorting
                    resizable: true, // Optional: resizable columns
                    floatingFilter: true, // Optional: show filter input below header
                  }}
                  getRowStyle={(params) => {
                    if (params.data?.disbursementStatus === "D") {
                      return { backgroundColor: "#b71c1c", color: "#fff" }; // Red background with white text for "D" status
                    }
                    return { backgroundColor: "#FFFFFF", color: "#1C2526" }; // Charcoal background with white text for other rows
                  }}
                  pagination={true}
                  paginationPageSize={100}
                  pinnedBottomRowData={recievablesNotInvfooterData}
                  animateRows={true}
                />
              </StyledAgGridContainer>
            </Grid>
          </Grid>
          <GstTdsGrid setAlert={showAlert} setLoading={setLoading} loading={loading} />
        </Box>
      )}
      {activeTab === 2 && <FinancialSummary isKh={false} />}
      {activeTab === 3 && <FinancialSummary isKh={true} />}
    </>
  );
}
